<template>
  {{ props.item[props.column.key] === true ? 'YES' : 'NO' }}
</template>

<script setup>
  
const props = defineProps({
  item: Object,
  column: Object
});

</script>